import Pick16PayoutCalculator from "./Pick16ParlayPayoutCalculator";

class PrizeAssetsPayoutCalculator{
    calculateDistribution(wager, prizeAsset) {
        const results = new Pick16PayoutCalculator().calculateDistribution(wager, 0);
        const last = results[results.length - 1];
        last.prizeAsset = prizeAsset;
        return results;
    }
}
export default PrizeAssetsPayoutCalculator;